import { game } from '../main';

export function createMultiLineText(
  x: number,
  y: number,
  font: string,
  text: string,
  size: number,
  max_width: number,
  max_height: number,
  align: string = 'center',
  hAnchor: number,
  vAnchor: number,
): Phaser.Text | MultiLineText {
  if (game.lang === 'ar') {
    const textObj = game.make.text(x, y, text, {
      fontSize: size,
      fill: 'white',
      align: align == 'left' ? 'right' : align,
      wordWrap: true,
      wordWrapWidth: max_width
    });
    textObj.anchor.setTo(hAnchor, vAnchor);

    if (max_width) {
      textObj.width = Math.min(max_width, textObj.width);
    }

    if (max_height) {
      textObj.height = Math.min(max_height, textObj.height);
    }

    return textObj;
  } else {
    return new MultiLineText(x, y, font, text, size, max_width, max_height, align, hAnchor, vAnchor);
  }
}

export class MultiLineText extends Phaser.Text {
  constructor(
    x: number,
    y: number,
    font: string,
    text: string,
    size: number,
    max_width: number,
    max_height: number,
    align: string = 'center',
    hAnchor: number,
    vAnchor: number,
  ) {
    super(game, x, y, '', {
      fontSize: size,
      fill: 'white',
      font: 'Comfortaa',
    });

    this.splitText(text, max_width);

    this.align = align || 'center';

    this.setShadow(2, 2, 'black', 0, false, true);

    if (max_height) {
      while (this.height > max_height) {
        this.fontSize -= 2;
        this.splitText(text, max_width);
        this.updateText();
        if (this.fontSize < 5) break;
      }
    }

    this.lineSpacing = -5;

    this.anchor.setTo(hAnchor, vAnchor);
  }

  private splitText(text: string, max_width: number): void {
    let txt = text;
    var txtArray: string[] = [];
    let prevIndexOfSpace = 0;
    let indexOfSpace = 0;

    while (txt.length > 0) {

      prevIndexOfSpace = indexOfSpace;
      indexOfSpace = txt.indexOf(' ', indexOfSpace + 1);

      if (indexOfSpace == -1) this.setText(txt);
      else this.setText(txt.substring(0, indexOfSpace));
      this.updateText();

      if (this.width > max_width) {
        if (prevIndexOfSpace == 0 && indexOfSpace == -1) {
          txtArray.push(txt);
          txt = '';
          indexOfSpace = 0;
          continue;
        }

        if (prevIndexOfSpace == 0) {
          txtArray.push(txt.substring(0, indexOfSpace));
          txt = txt.substring(indexOfSpace + 1);
          indexOfSpace = 0;
          continue;
        }

        txtArray.push(txt.substring(0, prevIndexOfSpace));
        txt = txt.substring(prevIndexOfSpace + 1);
        indexOfSpace = 0;
      } else {
        if (indexOfSpace == -1) {
          txtArray.push(txt);
          txt = '';
        }
      }
    }

    this.setText(txtArray.join('\n'));
  }
}